import React from 'react';
import { Link } from 'react-router-dom';
import { methodSteps } from '../../data/homeContent';
export function MethodSection() {
  return <section id="methode" aria-labelledby="methode-title" className="border-t border-line bg-paper-deep" data-id="element-68" data-mp="u11aygjjt5yf">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 lg:grid-cols-12 lg:px-10 lg:py-32" data-id="element-69" data-mp="ozkagm4z7lid">
        <div className="lg:col-span-5" data-id="element-70" data-mp="k225f6u2xqfn">
          <div className="lg:sticky lg:top-32" data-id="element-71" data-mp="g18kmmbxorqz">
            <h2 id="methode-title" className="font-display text-4xl font-medium leading-tight md:text-5xl" data-id="element-72" data-mp="g21isywtu8xi">
              Une méthode qui part du geste.
            </h2>
            <p className="mt-6 max-w-md leading-relaxed text-ink-soft" data-id="element-73" data-mp="6bys55d6h72c">
              Violoncelliste et formée à la santé du musicien, Elisabete relie la technique instrumentale
              à la connaissance du corps. Chaque cours avance en trois temps, toujours dans cet ordre.
            </p>
            <Link to="/methode" className="mt-8 inline-block border-b border-ink/40 pb-0.5 text-sm font-medium text-ink transition-colors duration-150 hover:border-wood hover:text-wood" data-id="element-74" data-mp="3oga7hvw8afke">
              Lire la méthode en détail
            </Link>
          </div>
        </div>

        <ol className="lg:col-span-6 lg:col-start-7" data-id="element-75" data-mp="vk4e1vs5bn83">
          {methodSteps.map((step, i) => <li key={step.title} className="grid grid-cols-[3rem_1fr] gap-4 border-t border-line py-10 first:border-t-0 first:pt-0" data-id="element-76" data-mp="10io4o9hopn6s" data-mpi={i}>
              <span className="font-display text-2xl italic text-wood" aria-hidden="true" data-id="element-77" data-mp="1o5nuqsvipeug">
                {i + 1}.
              </span>
              <div data-id="element-78" data-mp="1f7bz2cfsnqv5">
                <h3 className="font-display text-3xl font-medium" data-id="element-79" data-mp="1f60rs2n540za">{step.title}</h3>
                <p className="mt-3 max-w-md leading-relaxed text-ink-soft" data-id="element-80" data-mp="1j7mbo7y3dfiz">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}